/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 */

export const trimStringToLength = (copy?: string, length?: number) => {
  if (!copy || !length) {
    return undefined
  }
  return copy.length > length ? copy.substring(0, length).replace(/.$/, '…') : copy
}
